import { Notification } from './notification';
import styles from './notification.module.scss';
import { INotification } from './types';

type TNotificationList = {
  notifications: INotification[];
  hideNotification: (id: string) => void;
};

export const NotificationList = (props: TNotificationList) => {
  const { notifications, hideNotification } = props;

  if (!notifications.length) {
    return null;
  }

  return (
    <div className={styles.notificationContainer}>
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          id={notification.id}
          title={notification.title}
          message={notification.message}
          isAutoClose={notification.isAutoClose}
          onClose={() => hideNotification(notification.id)}
        />
      ))}
    </div>
  );
};
